import React from 'react';
import styles from './informer.module.sass';
import { Icon } from '../Icon';
import { IconSVG } from '../SpriteSVG';
import { Text } from '../Text';

export const Informer = () => (
  <div className={styles.informer}>
    <div className={styles.informerBlock}>
      <Icon
        icon={<IconSVG name={'promo/informer'} width={24} height={24} />}
        rightGap={8}
        title="Иконка телефона"
      />
      <div>
        <Text variant={'medicalInfo'}>
          Оплата после подтверждения менеджером
        </Text>
      </div>
    </div>
  </div>
);
